import { useCallback, useEffect, useState } from "react";

import { SignageAssistantChatArea } from "@/commands/Assistant/signageChatAreaComponent";
import {
  AssistantCommentWrapper,
  AssistantEndButton,
  AssistantEndButtonWrapper,
  AssistantStartButton,
} from "@/commands/Assistant/signageMode.style";
import { useMiibo } from "@/hooks/useMiibo";

type Props = {
  clientId: string;
};

export function AssistantSignageMode({ clientId }: Props) {
  const miiboHooks = useMiibo({
    code: clientId,
  });
  const [isStarted, setIsStarted] = useState<boolean>(false);

  const assistantEnd = useCallback(() => {
    setIsStarted(false);
    miiboHooks.reset();
  }, [miiboHooks]);

  useEffect(() => {
    let lastInteractionTime = Date.now();
    const handleUserInteraction = () => {
      lastInteractionTime = Date.now();
    };

    window.addEventListener("mousemove", handleUserInteraction);
    window.addEventListener("keydown", handleUserInteraction);

    const interval = setInterval(() => {
      if (!miiboHooks.isSpeaking) {
        if (Date.now() - lastInteractionTime > 300000) {
          if (isStarted) {
            assistantEnd();
          } else {
            window.location.reload();
          }
        } else {
          handleUserInteraction();
        }
      }
    }, 300000);

    return () => {
      clearInterval(interval);
      window.removeEventListener("mousemove", handleUserInteraction);
      window.removeEventListener("keydown", handleUserInteraction);
    };
  }, [assistantEnd, isStarted, miiboHooks.isSpeaking]);

  if (!isStarted) {
    return (
      <AssistantCommentWrapper>
        <AssistantStartButton
          type="button"
          onClick={() => {
            setIsStarted(true);
            miiboHooks.startMiibo();
          }}
        >
          会話を始める
        </AssistantStartButton>
      </AssistantCommentWrapper>
    );
  }

  return (
    <>
      <AssistantEndButtonWrapper>
        <AssistantEndButton type="button" onClick={assistantEnd}>
          会話を終了する
        </AssistantEndButton>
      </AssistantEndButtonWrapper>
      <SignageAssistantChatArea miiboHooks={miiboHooks} />
    </>
  );
}
